import { Flex } from '@mantine/core';
import { Message, MessageDirection } from '../chat/hooks/useChatMessages';
import { SiestaMessage } from './SiestaMessage';
import { UserMessage } from './UserMessage';

type Props = {
  messages: Message[];
  latestIncomingId?: string;
  isStreaming?: boolean;
};

export function SiestaBarMessages({ messages, latestIncomingId, isStreaming }: Props) {
  return (
    <Flex direction="column" gap="md" px="md" py="md">
      {messages.map(message => {
        if (message.direction === MessageDirection.Outgoing) {
          return (
            <UserMessage
              key={message.id}
              content={message.answerContent || message.response[0]?.content || ''}
            />
          );
        }

        const isLatest = message.id === latestIncomingId;
        const isThinking =
          isLatest &&
          isStreaming &&
          message.currentState !== 'ANSWERING' &&
          message.currentState !== 'SENT' &&
          message.currentState !== '';

        return (
          <SiestaMessage
            key={message.id}
            content={message.answerContent}
            thinkingContent={message.thinkingContent}
            isThinking={isThinking}
            currentState={message.currentState}
            currentToolName={isThinking ? message.currentToolName : undefined}
          />
        );
      })}
    </Flex>
  );
}
